import { render, staticRenderFns } from "./FeaturedItems5Template.vue?vue&type=template&id=fdcce2ec"
import script from "./FeaturedItems5Template.vue?vue&type=script&lang=js"
export * from "./FeaturedItems5Template.vue?vue&type=script&lang=js"
import style0 from "./FeaturedItems5Template.vue?vue&type=style&index=0&id=fdcce2ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports